module.exports = __webpack_public_path__ + "static/media/Header-Logo-white.cc4a0ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Header-Logo-white.png
// module id = 716
// module chunks = 0